/**
 * Default Page HTML template — the content-only prefill (epic 042 README
 * §Architecture decisions 7, operator's example block). Prefilled into the
 * Main Content editor when a NEW hosted-page campaign form opens; the
 * prefill mechanics are content-agnostic.
 *
 * Epic 042 shrank 037-01's full scoped template to this snippet: the offer-page
 * chrome (background, logo header, white card, CTA box, disclaimers, skip box,
 * footer) is now platform-owned (landing-client render), and the campaign
 * contributes only the content block. The heading is the content's first line
 * (no separate headline); her "Add … here" placeholders are kept as editing
 * placeholders — that is the point of a template.
 *
 * A fragment, not a document: no <html>/<head>/<body>, no <style>, no font
 * imports, no anchors/forms/tracking mechanics — the WYSIWYG editor parses and
 * re-serializes exactly this shape (h2 / image / copy / hyperlink / bullets).
 */
export const DEFAULT_PAGE_HTML = `<h2>Add headline here</h2>
<p></p>
<p>Add content here</p>
<p></p>
<p><a href="https://example.com">Add Hyperlinked content here</a></p>
<p></p>
<ul><li>Add bullet points here</li><li>Add bullet points here</li></ul>`;
